import React from 'react';
import { useNavigate } from 'react-router-dom';
import './NotFoundPage.css';

/**
 * Página 404 - No encontrada
 */
const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div className="not-found-page">
      <div className="not-found-content">
        <h1>404</h1>
        <h2>Página no encontrada</h2>
        <p>La página que buscas no existe o ha sido movida.</p>
        <button 
          className="btn-home"
          onClick={() => navigate('/')}
        >
          Volver al inicio
        </button>
      </div>
    </div>
  );
};

export default NotFoundPage;

